<div [@animation] *ngIf="open" class="fixed z-50 flex flex-row justify-end inset-0" [ngClass]="{'p-4': floating}">
    <div (click)="aClose()" class="drawer fixed inset-0 z-40 bg-zenMain bg-opacity-30 transition-opacity duration-300" 
         [ngClass]="{'opacity-0 pointer-events-none': !showBackDrop}">
    </div>
    <div (click)="$event.stopPropagation()"
        class="relative z-50 bg-zen-background overflow-overlay shadow-sm innerListScroll h-full flex flex-col"
        [ngClass]="[dir == 'rtl' ? 'rtl' : 'ltr', floating ? 'rounded-lg' + ' shadow-2xl overflow-hidden' : 'w-auto min-h-full max-h-screen']">
        
        <div class="flex flex-row justify-between items-center px-10 py-8 sticky top-0 bg-white z-50">
            <div class="flex flex-row w-full justify-between items-center">
                <ng-content select="[header]"></ng-content>
            </div>
        </div>

        <div class="flex flex-col justify-start items-stretch flex-grow">
            <ng-content select="[body]"></ng-content>
        </div>

        <div class="flex flex-row justify-between items-center px-10 py-3 mt-auto">
            <ng-content select="[footer]"></ng-content>
        </div>
    </div>
</div>